module.exports = __webpack_public_path__ + "media/video-regles.6dfc3194.mp4";